var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSs = function SvgIconSs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.063 7.347C21.246 3.03 16.977 0 12 0a11.96 11.96 0 0 0-8.485 3.515L6.52 7.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "m6.554 16.608-3.04 3.876A11.96 11.96 0 0 0 12 23.999c4.994 0 9.275-3.051 11.082-7.391z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M2.608 8.826v6.304h20.978c.27-.998.414-2.047.414-3.13 0-1.099-.148-2.163-.425-3.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m3.909 9.016 1.465 2.044L7.77 10.3 6.28 12.323l1.465 2.044-2.387-.792-1.49 2.024.015-2.514-2.386-.793 2.397-.761z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconSs;